import { ServiceProvider } from '@goodt-common/service-provider';
import { HttpTransportCacheServiceSymbol } from '@goodt-common/cache';
import { Http } from './Http';
import { HttpAuth } from './HttpAuth';
import { TransportFactoryError } from './errors';

/**
 * @implements {ITransportFactory}
 * @param {ITransportOptions} [options={}]
 * @param {ITransportExtraOptions} [extraOptions={}]
 * @return {Http}
 */
const createHttp = (options, extraOptions) => new Http(options, extraOptions);

/**
 * @implements {ITransportFactory}
 * @param {ITransportOptions} [options={}]
 * @param {ITransportExtraOptions} [extraOptions={}]
 * @return {HttpAuth}
 */
const createHttpAuth = (options, extraOptions) => new HttpAuth(options, extraOptions);

/** @type {symbol} */
export const HttpTransportSymbol = Symbol('HttpTransport');
/** @type {symbol} */
export const HttpAuthTransportSymbol = Symbol('HttpAuthTransport');

/**
 * @type {Map<symbol, Function>}
 */
export const TransportFactoryMap = new Map();
TransportFactoryMap.set(HttpTransportSymbol, createHttp);
TransportFactoryMap.set(HttpAuthTransportSymbol, createHttpAuth);

/**
 * @param {symbol} transportId
 * @param {Record<string, any>} [options={}]
 * @param {Record<string, any>} [extraOptions={}]
 * @throws {TransportFactoryError}
 * @return {ITransport}
 */
export const createTransport = (transportId, options = {}, extraOptions = {}) => {
    const transportFactory = TransportFactoryMap.get(transportId);
    if (transportFactory == null) {
        throw new TransportFactoryError(
            `Transport factory for specified identifier '${transportId.toString()}' does not exist.`
        );
    }
    const cacheService = ServiceProvider.get(HttpTransportCacheServiceSymbol);
    const transport = transportFactory(options, extraOptions);

    if (cacheService.isEnabled) {
        return cacheService.wrap(transport);
    }

    return transport;
};
